import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "isLongText",
  standalone: false,
})
export class IsLongTextPipe implements PipeTransform {
  transform(text: string): boolean {
    return text.length > 20;
  }
}
